var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoOrange(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 121,
    viewBox: "0 0 120 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.679 1.39111V57.4411H23.8896C23.8896 57.4411 0.810791 53.3252 0.810791 29.4161C0.810791 5.16666 23.8896 1.39111 23.8896 1.39111",
    fill: "#F04D24"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3145 119.769V63.7192H96.1038C96.1038 63.7192 119.636 67.8351 119.183 91.7442C118.729 115.653 96.1038 119.769 96.1038 119.769",
    fill: "#F04D24"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.883678 63.7192V94.3774C0.883678 94.3774 -0.94515 119.769 32.5644 119.769H56.6709V91.25C56.6709 91.25 57.4963 63.7192 25.3624 63.7192H0.883678Z",
    fill: "#F04D24"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3306 1.39111V32.0492C63.3306 32.0492 61.5017 57.4411 95.0113 57.4411H119.118V28.9219C119.118 28.9219 119.943 1.39111 87.8093 1.39111H63.3306Z",
    fill: "#F04D24"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoOrange);
export default __webpack_public_path__ + "static/media/logo-orange.609a47a1066af3ca425772a95a775b1b.svg";
export { ForwardRef as ReactComponent };